var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E8EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.875C14.1738 13.875 15.9375 12.1113 15.9375 9.9375C15.9375 7.76367 14.1738 6 12 6C9.82617 6 8.0625 7.76367 8.0625 9.9375C8.0625 12.1113 9.82617 13.875 12 13.875ZM15.5 14.75H13.9934C13.3863 15.0289 12.7109 15.1875 12 15.1875C11.2891 15.1875 10.6164 15.0289 10.0066 14.75H8.5C6.5668 14.75 5 16.3168 5 18.25V18.6875C5 19.4121 5.58789 20 6.3125 20H17.6875C18.4121 20 19 19.4121 19 18.6875V18.25C19 16.3168 17.4332 14.75 15.5 14.75Z",
    fill: "#1E447D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/defaultUser.fbe62c8a15426f1798304fe833acd31a.svg";
export { ForwardRef as ReactComponent };